import React from 'react'
import { useTranslation } from 'react-i18next'

import styles from './InfoPopup.module.scss'

interface Props {
  className?: string
}

const InfoPopup: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.popup}>
      <p>{t('create_bottle.popup.text')}</p>
      <div />
    </div>
  )
}

export default InfoPopup
